<app-header></app-header>

<div class="booking-create container">
  <button class="button button--white button--small"
          [disabled]="photographerSlug === null"
          [routerLink]="['/photographer', photographerSlug]"
  >
    <i class="fa-solid fa-arrow-left"></i>
    {{'marketplace.booking.create.back'|transloco}}
  </button>

  <div class="booking-create-container">
    @if (!service) {
      <div class="service" >
        <div class="service__main-image skeleton-loading"></div>
        <div class="service__title skeleton-loading"></div>
        <div class="service__price skeleton-loading"></div>
        <div class="service__description skeleton-loading"></div>
      </div>
    }

    @if (service) {
      <div class="service">
        @if (getMainImage()) {
          <div class="service__main-image">
            <app-image
              [src]="getMainImage()!"
              [alt]="service.name"
              preset="card"
              aspectRatio="1"
              [sizes]="'320px'"
              [width]="320"
              [height]="320"
            ></app-image>
          </div>
        }
        <h1 class="service__title">{{service.name}}</h1>
        @if (service.priceRangeActive) {
          @if (service.discountActive) {
            <p class="service__price">
              {{'service.pricing.starting-at'|transloco}}
              <span class="old">{{service.priceRangeMinPublic|currency:'EUR'}}</span>
              <span class="new">{{((service.priceRangeMinPublic ?? 0) * (1 - (service.discount ?? 0)/100))|currency:'EUR'}}</span>
            </p>
          } @else {
            <p class="service__price">{{'service.pricing.starting-at'|transloco}} {{service.priceRangeMinPublic|currency:'EUR'}}</p>
          }
        } @else {
          @if (service.discountActive) {
            <p class="service__price">
              <span class="old">{{service.publicPrice|currency:'EUR'}}</span>
              <span class="new">{{((service.publicPrice) * (1 - (service.discount ?? 0)/100))|currency:'EUR'}}</span>
            </p>
          } @else {
            <p class="service__price">{{service.publicPrice|currency:'EUR'}}</p>
          }
        }

        @if (formatDuration(service.duration)) {
          <div class="service__tags">
            <span class="tag">
              <i class="fa-regular fa-clock"></i>
              {{ formatDuration(service.duration) }}
            </span>
          </div>
        }

        <p class="service__description"
          [innerHTML]="getFormattedServiceDescription(service)"
        ></p>
      </div>
    }

    <div class="booking">
      @if (service?.photos?.length) {
        <section class="sf-section service-carousel">
          <div class="sf-section__header">
            <h2 class="sf-section__title">{{'marketplace.booking.create.photos.title'|transloco}}</h2>
          </div>
          <p class="sf-section__subtitle">{{'marketplace.booking.create.photos.subtitle'|transloco}}</p>
          <app-inline-carousel [photos]="getGalleryPhotos()"></app-inline-carousel>
        </section>
      }

      <section class="sf-section">
        <div class="sf-section__header">
          <h2 class="booking__title">{{'marketplace.booking.create.select-date-form.title'|transloco}}</h2>
        </div>
        <p class="sf-section__subtitle">{{'marketplace.booking.create.select-date-form.subtitle'|transloco}}</p>
        <form class="booking__form"
              [formGroup]="bookingForm"
              (ngSubmit)="onSubmit()"
        >
          <div class="input-group">
            <label>{{ 'marketplace.booking.create.select-date-form.select-a-date.label' | transloco }}</label>
            <app-date-time-picker
              [serviceId]="service?.id ?? null"
              [locale]="activeLocale"
              (dateSelected)="onDateSelected($event)"
              (selectionChange)="onDateTimeSelected($event)"
            ></app-date-time-picker>
            <input type="hidden" formControlName="date" />
            <input type="hidden" formControlName="hour" />
            <input type="hidden" formControlName="minute" />
            @if (bookingForm.get('date')?.invalid && bookingForm.get('date')?.touched) {
              <div class="error">
                {{ 'marketplace.booking.create.select-date-form.select-a-date.errors.invalid' | transloco }}
              </div>
            }
            @if (bookingForm.get('date')?.errors?.['notInFuture'] && bookingForm.get('date')?.touched) {
              <div class="error">
                {{ 'marketplace.booking.create.select-date-form.select-a-date.errors.future' | transloco }}
              </div>
            }
            @if ((bookingForm.get('hour')?.invalid || bookingForm.get('minute')?.invalid) && bookingForm.touched) {
              <div class="error">
                {{ 'marketplace.booking.create.select-date-form.select-a-date.time.error' | transloco }}
              </div>
            }
          </div>

          @if (service && service.priceRangeActive) {
            <app-helper-banner>
              <div helper-content>
                <p>{{ 'marketplace.booking.create.price-range.help' | transloco: {'min': ((service.priceRangeMinPublic ?? 0) * (1 - (service.discount ?? 0) / 100)), 'max': ((service.priceRangeMaxPublic ?? 0) * (1 - (service.discount ?? 0) / 100))} }}</p>
              </div>
            </app-helper-banner>

            <div class="input-group">
              <label>{{ 'marketplace.booking.create.price-range.label' | transloco }}</label>
              <input type="number"
                     step="0.01"
                     min="{{((service.priceRangeMinPublic ?? 0) * (1 - (service.discount ?? 0) / 100))}}"
                     max="{{((service.priceRangeMaxPublic ?? 0) * (1 - (service.discount ?? 0) / 100))}}"
                     formControlName="price"
                     placeholder="{{ 'marketplace.booking.create.price-range.placeholder' | transloco }}"
              />
              @if (service && service.priceRangeMinPublic && bookingForm.value.price < ((service.priceRangeMinPublic) * (1 - (service.discount ?? 0) / 100))) {
                <p class="error">{{'marketplace.booking.create.price-range.error.too-low' | transloco}}</p>
              }
              @if (service && service.priceRangeMaxPublic && bookingForm.value.price > ((service.priceRangeMaxPublic) * (1 - (service.discount ?? 0) / 100))) {
                <p class="error">{{'marketplace.booking.create.price-range.error.too-high' | transloco}}</p>
              }
              @if (bookingForm.value.price === null || bookingForm.value.price === '') {
                <p class="error">{{'marketplace.booking.create.price-range.error.empty' | transloco}}</p>
              }
            </div>
          }

          <div class="input-group--side-by-side">
            <div class="input-group">
              <label>{{ 'register.firstname.label' | transloco }}</label>
              <input
                type="text"
                formControlName="firstname"
                placeholder="{{ 'register.firstname.placeholder' | transloco }}" />
            </div>
            <div class="input-group">
              <label>{{ 'register.lastname.label' | transloco }}</label>
              <input
                type="text"
                formControlName="lastname"
                placeholder="{{ 'register.lastname.placeholder' | transloco }}" />
            </div>
          </div>

          <div class="input-group">
            <label>{{ 'marketplace.booking.create.select-date-form.note.label' | transloco }}</label>
            <textarea
              formControlName="note"
              [placeholder]="'marketplace.booking.create.select-date-form.note.placeholder' | transloco"
            ></textarea>
          </div>

          @if (!user) {
            <div class="input-group">
              <label>{{ 'marketplace.booking.create.select-date-form.email.label' | transloco }}</label>
              <input type="email" formControlName="email" />
              @if (bookingForm.get('email')?.invalid && bookingForm.get('email')?.touched) {
                <div class="error">
                  {{ 'marketplace.booking.create.select-date-form.email.errors.invalid' | transloco }}
                </div>
              }
            </div>
          }

          @if (service && canPayDeposit()) {
            <div class="input-group">
              <label>{{ 'marketplace.booking.create.payment.label' | transloco }}</label>
              <app-segmented-control
                [options]="paymentOptions"
                [value]="bookingForm.value.paymentMode"
                (valueChange)="onPaymentModeChange($event)"
              ></app-segmented-control>
            </div>
          }

          <button
            type="submit"
            class="button button--primary button--large button--full-width"
            [disabled]="bookingForm.invalid || submitting"
          >
            {{ 'marketplace.booking.create.select-date-form.confirm.label' | transloco }}
            <i class="fa-solid fa-arrow-right"></i>
          </button>
        </form>
      </section>

    </div>
  </div>
</div>
